<template>
    <ModalTheme :with-content="true" @close="closeModal" :theme="true" :fix-height="false">
        <template slot="main">
            <loader :loading="true" v-if="loading"></loader>
            <TextInputBloc :label="'Name'" :required="true" v-model="name" :validator="FORM_VALIDATORS.name" :max-length="40"></TextInputBloc>
            <br />
            <TextInputBloc
                :label="'Reference'"
                :required="true"
                v-model="reference"
                :validator="FORM_VALIDATORS.name"
                :max-length="40"
            ></TextInputBloc>
            <br />
            <ClientColorButton :disabled="!canSubmit" @click="save">Create</ClientColorButton>
        </template>
    </ModalTheme>
</template>

<script>
import ModalTheme from "@/components/ui/ModalTheme";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import TryLoad from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import { mapActions } from "vuex";
import { OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";
import historyService from "@/services/history";
import componentService from "@/services/component";

export default {
    components: { TextInputBloc, ModalTheme, loader },
    props: {
        forecast: {
            type: Object,
            required: true
        }
    },
    mixins: [TryLoad],
    data() {
        return {
            name: "",
            reference: ""
        };
    },
    computed: {
        canSubmit() {
            return this.name !== "" && this.reference !== "";
        }
    },
    methods: {
        ...mapActions("forecast", { duplicateForecast: "duplicateForecast" }),
        closeModal() {
            this.$emit("closed");
        },
        save() {
            try {
                this.tryLoad(() => this.duplicateForecast({ forecast: this.forecast, name: this.name, reference: this.reference }))
                    .then(async duplicatedForecast => {
                        this.$emit("closed");
                        this.$emit("duplicated", duplicatedForecast);
                    })
                    .catch(() => {
                        this.$swal({
                            text: "ERROR TO DUPLICATE FORECAST",
                            type: "error",
                            confirmButtonText: "OK",
                            confirmButtonColor: "rgb(135, 135, 135)",
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        });
                    });
            } catch (e) {
                console.error(e);
                window.alert(e);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// DuplicationModal.vue?0ee2bff6